import { CreateEmployeeParams, GetEmployeeListParams } from "../types/types";
import { api } from ".";

const basePath = "/employee";

export const createEmployee = async ({
  name,
  phone,
  employmentType,
  roleIds,
  contractId,
  assignedSkillIds,
  departmentIds,
  hireDate,
  isWorkingCurrently,
  birthday,
}: CreateEmployeeParams) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      phone,
      departmentIds,
      employmentType,
      roleIds,
      contractId,
      assignedSkillIds,
      hireDate,
      isWorkingCurrently,
      birthday,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateEmployeeById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getEmployeeById = async (id: string) => {
  try {
    const res = await api.get(`${basePath}?_id=${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getEmployeeList = async (params: GetEmployeeListParams) => {
  try {
    const res = await api.get(`${basePath}/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const getEmployeeActivities = async ({
  pageNumber,
  limit,
  sort,
  date,
  activity,
  id,
}: {
  pageNumber?: number;
  limit?: number;
  sort?: string;
  date?: string;
  activity?: string;
  id?: string;
}) => {
  try {
    const params: Record<string, any> = {};
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;
    if (sort !== undefined) params.sort = sort;
    if (date !== undefined) params.date = date;
    if (activity !== undefined) params.activity = activity;
    if (id !== undefined) params._id = id;

    const res = await api.get(`${basePath}/activities`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteEmployee = async ({ id }: any) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getDepartmentList = async () => {
  try {
    const res = await api.get(`${basePath}/departments`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getPositionsList = async () => {
  try {
    const res = await api.get(`${basePath}/positions`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getAllEmployees = async () => {
  try {
    const res = await api.get(`${basePath}/allEmployees`);
    return res;
  } catch (error) {
    return error;
  }
};

export const assignShift = async ({
  shiftId,
  startTime,
  selectedIds,

  shiftEndTime,
}: any) => {
  try {
    const res = await api.post(`${basePath}/assignShift`, {
      shiftId,
      startTime,
      selectedIds,
      shiftEndTime,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getActiveShiftsByUserId = async ({ userId }: any) => {
  try {
    const res = await api.get(`${basePath}/activeShifts`, {
      params: { userId },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteShiftFromUser = async ({ userId, userShiftId }: any) => {
  try {
    const res = await api.patch(`${basePath}/unassignShift`, {
      userId,
      userShiftId,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const uploadEmployeeDocument = async ({
  file,
  employeeId,
  name,
  fileId,
}: {
  file: File;
  employeeId: any;
  name?: any;
  fileId?: any;
}) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("employeeId", employeeId);
    formData.append("name", name);
    formData.append("fileId", fileId ? fileId : "");

    const res = await api.post(`${basePath}/documents/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res;
  } catch (error) {
    console.error("Error uploading document:", error);
    return error;
  }
};

export const downloadEmployeeDocument = async (fileId: string) => {
  try {
    const res = await api.get(`/employee/documents/download/${fileId}`, {
      responseType: "blob", // <== BU ÇOK ÖNEMLİ: binary veri indiriyoruz
    });
    const blob = new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);

    // Dosya adını response'tan almaya çalış
    const contentDisposition = res.headers["content-disposition"];
    let filename = "downloaded-file";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        filename = decodeURIComponent(match[1]);
      }
    }

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    // Temizlik
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading document:", error);
    return error;
  }
};

export const previewEmployeeDocument = async (fileId: string) => {
  try {
    const res = await api.get(`/employee/documents/download/${fileId}`, {
      responseType: "blob", // dosyayı binary olarak alıyoruz
    });

    const blob = new Blob([res.data], { type: res.data.type });
    const url = window.URL.createObjectURL(blob);

    // Yeni sekmede aç
    window.open(url, "_blank");

    // Temizlik (birkaç saniye gecikmeli silmek daha güvenli olur)
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 5000);
  } catch (error) {
    console.error("Error previewing document:", error);
    return error;
  }
};

export const deleteEmployeeDocument = async ({
  fileId,
  employeeId,
}: {
  fileId: string;
  employeeId: string;
}) => {
  try {
    const res = await api.delete(
      `${basePath}/documents/delete/${fileId}/${employeeId}`
    );

    return res;
  } catch (error) {
    console.error("Error deleting document:", error);
    return error;
  }
};
